/** "99+" past ninety-nine: a count that wide only says "a lot". */
export function badgeText(unread: number): string {
  return unread > 99 ? '99+' : String(unread);
}
